import React, { memo, ReactElement, cloneElement } from 'react';
import { createUseStyles } from 'react-jss';
import { Input, Form, Radio, InputProps, Col, Row } from 'antd';
import {
  MobileOutlined,
  UserOutlined,
  LockOutlined,
  EyeInvisibleOutlined,
  EyeTwoTone,
} from '@ant-design/icons';
import { COLORS, i18n, useLanguage, useThemes } from 'core';
import { ActivationCodeRequest, Button, Text } from 'components/src';

import { REGISTRYCODE, MOBILENUMBER,USERNAME, NEWPASSWORD, useLogic } from './logic';
import { MdOutlineSmsFailed } from 'react-icons/md';
//@ts-ignore
import loginLogo1 from "assets/src/img/login-logo.png";
//@ts-ignore
import loginLogo2 from "assets/src/img/login-logo2.png";
//@ts-ignore
import Logo1 from "assets/src/img/logo-text.png";
//@ts-ignore
import Logo2 from "assets/src/img/logo-text2.png";
import {
  useFormContext,
  Controller,
  RegisterOptions,
  FormProvider,
} from 'react-hook-form';



const useStyles = createUseStyles<string, unknown, COLORS>(
  (colors) => ({
    forgetPass: {
      display: 'flex',
      justifyContent: 'center',
      textDecoration: 'none',
      color: colors?.gray,
      marginTop: '20px',
      '&:hover': {
        color: colors.theme01,
      },
    },
    login: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      width: '100%',
      backgroundColor: colors.black01,
      color: 'white',
      '& .ant-typography': {
        color: colors.red,
      },
    },
    loginLogo: {
      '& img': {
        width: '240px',
        height: '240px',
      },
    },
    pic: {
      '@media (max-width: 768px)': {
        display: 'none',
      },
    },
    loginRight: {
      backgroundColor: colors.black02,
      boxShadow: `2px 1px 20px ${colors.theme01}`,
      borderRadius: '5px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '20px',
      width: '500px',
      height: '500px',
      '& h1': {
        fontSize: '40px',
        marginBottom: '20px',
      },
      '& h4': {
        fontWeight: '500',
        marginTop: '40px',
        fontSize: '15px',
        color: colors.gray01,
      },
    },
    loginInputEmail: {
      display: 'flex',
      alignItems: 'center',
      color: colors.white,
      backgroundColor: colors.black02,
      borderRadius: '5px',
      padding: '3px',
      width: '98%',
      height: '50px',
      '& .icon-prefix': {
        color: colors.gray,
      },
      '& .ant-input-prefix': {
        color: colors.gray,
      },
      '& .ant-input-password-icon': {
        color: `${colors.gray} !important`,
        '& svg': {
          margin: `5px !important`,
        },
      },
      '&:hover': {
        color: colors.white,
        '& .icon-prefix': {
          color: colors.white,
        },
        '& .ant-input-prefix': {
          color: colors.white,
        },
        '& .ant-input-password-icon': {
          color: `${colors.white} !important`,
        },
      },
      '& svg': {
        marginLeft: '30px',
        fontSize: '30px',
      },
      '& input': {
        backgroundColor: 'transparent',
        width: '100%',
        outlineWidth: 0,
        color: colors.white,
        border: 'none',
        fontSize: '17px',
        marginLeft: '10px',
        marginRight: '10px',
        '&::placeholder': {
          color: colors.gray, // Change the color to your desired value
        },
        '& .ant-input-password-icon': {
          color: `${colors.white} !important`,
        },
      },
    },
    inputTransition: {
      transition: 'opacity 0.5s, transform 0.5s',
      opacity: 1,
      transform: 'translateX(0)',
      visibility: 'visible',
    },
    hidden: {
      opacity: 0,
      transform: 'translateX(-100%)', // Adjust the direction and distance as needed
      visibility: 'hidden',
    },

    activationContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },

    btnButton: {
      backgroundColor: colors.theme01,
      color: colors.white01,
      width: '98%',
      height: '40px',
      borderRadius: '5px',
      marginTop: '5px',
      border: 'none',
      outlineWidth: 0,
      '&:disabled': {
        cursor: 'not-allowed',
        borderColor: colors.gray,
        color: colors.white,
        backgroundColor: colors.gray,
        boxShadow: 'none',
      },
      '& span': {
        fontSize: '18px',
        fontWeight: '800',
      },
      '&:hover': {
        backgroundColor: colors.orangeA100,
        color: colors.white01,
        cursor: 'pointer',
        '&:disabled': {
          cursor: 'not-allowed',
          borderColor: colors.gray,
          color: colors.white,
          backgroundColor: colors.gray,
          boxShadow: 'none',
        },
      },
    },
    radio: {
      display: 'flex',
    },
  })
);

const ForgetPassword: React.FC = memo(() => {
  const classes = useStyles();
  const {template}=useThemes()
  const {
    handleSubmit,
    register,
    type,
    methods,
    forgetPassword,
    isVerified,
    counter,
    counterStatus,
    isLoading,
    requestCode,
  } = useLogic();
  const { isRtl } = useLanguage();
  return (
    <div className={classes.login}>
      <Row
        gutter={16}
        justify="space-between"
        align="middle"
        style={{ height: '100vh' }}
      >
        <Col xs={24} md={5} className={classes.loginLogo}>
          <Row className={classes.pic} justify={'center'}>
            {' '}
            <img src={template==="01"?loginLogo1:loginLogo2} />
          </Row>
          <Row justify={'center'}>
            {' '}
            <img
              style={{ height: '60px', marginTop: '20px' }}
              src={template==="01"?Logo1:Logo2}
            />
          </Row>
        </Col>
        <Col xs={23} md={16} className={classes.loginRight}>
          <Text>
            <h1>{i18n.t('forgetPassword')}</h1>
          </Text>
          <FormProvider {...methods}>
            <Form onFinish={handleSubmit(forgetPassword)}>

           {!isVerified && <><Form.Item>
                <InputContainer
                  name={USERNAME}
                  errorStyle={classes.error}
                  rules={{
                    required: i18n.t('isRequired'),
                    valueAsNumber: true,
                  }}
                >
                  <Input
                    autoComplete="off"
                    prefix={<UserOutlined className="icon" />}
                    placeholder={i18n.t('userName')}
                    className={classes.loginInputEmail}
                  />
                </InputContainer>
              </Form.Item>


              <Form.Item>
                <InputContainer
                  name={MOBILENUMBER}
                  errorStyle={classes.error}
                  rules={{
                    required: i18n.t('isRequired'),
                    valueAsNumber: true,
                  }}
                >
                  <Input
                    autoComplete="off"
                    prefix={<MobileOutlined className="icon" />}
                    placeholder={i18n.t('phoneNumber')}
                    className={classes.loginInputEmail}
                  />
                </InputContainer>
              </Form.Item></>}

              {isVerified && (
                <>
                  <Form.Item>
                    <div className={classes.inputTransition}>
                      <InputContainer
                        name={NEWPASSWORD}
                        errorStyle={classes.error}
                        rules={{
                          required: i18n.t('isRequired'),
                          valueAsNumber: true,
                        }}
                      >
                        <Input.Password
                          prefix={<LockOutlined className="icon" />}
                          placeholder={i18n.t('password')}
                          className={classes.loginInputEmail}
                          iconRender={(visible) =>
                            visible ? (
                              <EyeTwoTone />
                            ) : (
                              <EyeInvisibleOutlined />
                            )
                          }
                        />
                      </InputContainer>
                    </div>
                  </Form.Item>
                  <Form.Item>
                    <div
                      className={
                        isVerified
                          ? classes.inputTransition
                          : classes.hidden
                      }
                    >
                      <InputContainer
                        name={REGISTRYCODE}
                        errorStyle={classes.error}
                        rules={{
                          required: i18n.t('isRequired'),
                          valueAsNumber: true,
                        }}
                      >
                        <Input
                          prefix={
                            <MdOutlineSmsFailed className="icon" />
                          }
                          placeholder={i18n.t('verificationCode')}
                          className={classes.loginInputEmail}
                        />
                      </InputContainer>
                    </div>
                  </Form.Item>
                </>
              )}
              {/* Assuming you have some state management for Radio.Group */}
              {!isVerified && (
                <Form.Item>
                  <Radio.Group
                    className={classes.radio}
                    style={{
                      justifyContent: isRtl ? 'right' : 'left',
                    }}
                    defaultValue={type}
                    {...register('type')}
                  >
                    {/* <Radio value={'voip'}>{i18n.t('call')}</Radio> */}
                    <Radio value={'sms'}>{i18n.t('sms')}</Radio>
                  </Radio.Group>
                </Form.Item>
              )}
              <div className={classes.activationContainer}>
                {isVerified && (
                  <ActivationCodeRequest
                    {...{ counter, counterStatus, requestCode }}
                  />
                )}
              </div>
              <Button
                htmlType="submit"
                {...{ isLoading }}
                disabled={isLoading}
                className={classes.btnButton}
              >
                {!isVerified ? i18n.t('sendCode') : i18n.t('done')}
              </Button>
            </Form>
          </FormProvider>
        </Col>
      </Row>
    </div>
  );
});
type Props = InputProps & {
  name: string;
  rules?: RegisterOptions;
  children: ReactElement;
  errorStyle?: any;
};
const InputContainer = memo<Props>(
  ({ name, children, className, errorStyle, rules, ...rest }) => {
    const { control } = useFormContext(); // Hook into react-hook-form
    const { colors } = useThemes();
    return (
      <Controller
        {...rest}
        {...{ rules, control, name, className }}
        render={({ field, fieldState: { error } }) => (
          <>
            {cloneElement<InputProps>(children, {
              ...field,
              style: { borderColor: error && colors.red },
            })}
            {error && (
              <Text className={errorStyle}>{error.message}</Text>
            )}
          </>
        )}
      />
    );
  }
);

export { ForgetPassword };
